const getTotal = (statistics, status) => {
  return statistics.reduce((acc, item) => {
    if (item.status === status) {
      return item.total
    }

    return acc
  }, 0)
}

export default {
  afterPrepareShow () {
    this.scheduled = getTotal(this.statistics, 'scheduled')
    this.canceled = getTotal(this.statistics, 'canceled')
    this.attended = getTotal(this.statistics, 'attended')
    this.total = this.statistics.reduce((acc, item) => {
      return acc + item.total
    }, 0)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/agendas-statistics/resources/methods.js